


















import Vue from "vue";

export default Vue.extend({
  name: "cwx-chip",

  props: {
    //Creates chips without the closing icon
    withoutClose: {
      type: Boolean,
      required: false,
      default: false
    },
    //Disables the chip, making it un-selectable
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    //Used for selects/tagging. Applies a selection style to the chip.
    selected: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});
